<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading"
    >Loading ...
  </a-card>
  <a-form :form="form" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="Report Date">
          <a-date-picker
            placeholder="Select Date"
            disabled
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="PIC" v-if="getAuth.username !== initialData.pic">
          <div style="display: none">
            <a-input
              disabled
              v-decorator="[
                'pic',
                { rules: [{ required: true }], initialValue: initialData.pic },
              ]"
            ></a-input>
          </div>
          <a-input disabled v-model="pic_name"></a-input>
        </a-form-item>
        <a-form-item label="Petty cash type">
          <a-radio-group
            :disabled="isDisable"
            button-style="solid"
            v-decorator="[
              'type',
              { rules: [{ required: true }], initialValue: initialData.type },
            ]"
          >
            <a-radio-button value="nonbod"> Non BOD </a-radio-button>
            <a-radio-button value="bod"> BOD </a-radio-button>
          </a-radio-group>
        </a-form-item>

        <!-- <a-form-item label="Executive">
          <a-select
            disabled
            placeholder="Please select Executive"
            v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
            @change="handleBOD"
          >
            <a-select-option v-for="data in wo_bod" :key="data.tlc"
              >{{ data.tlc }} - {{ data.nama }}</a-select-option
            >
          </a-select>
        </a-form-item> -->
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "informasiKasKecil",
  props: {
    data: {},
    others: {},
    mode: String,
    active: false,
    dataList: {},
    disabled: false
  },
  data() {
    return {
      listNoSPPD: [],
      pageLoading: true,
      pic: "",
      pic_name: "",
      bod: "",
      type: "nonbod",
      wo_bod: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Create" && !this.active) {
      this.listNoSPPD = [];
      this.fetchBodPic();
    } else {
      this.pageLoading = false;
      this.fetchBodPic();
    }

    this.$store.dispatch("FETCH_ACTIVE_PROJECTKK");
    axios({
      method: "get",
      url: this.$serviceUrl + "bod",
      params: {
        "X-API-KEY": this.getAuth.apikey,
      },
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password,
      },
    })
      .then((response) => {
        //console.log(response);
        this.wo_bod = response.data.bod;
      })
      .catch((err) => {
        this.displayMessage("error-connection");
      });
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          tanggal_pelaporan: moment(),
          pic: this.pic,
          pic_name: this.pic_name,
          bod: this.bod,
          type: this.type,
        };
      } else {
        return {
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          pic: this.pic,
          pic_name: this.pic_name,
          bod: this.bod,
          type: this.data.type,
        };
      }
    },
    isDisable(){
      return this.dataList.length > 0 ? true : false
    }
  },
  methods: {
    moment,
    fetchBodPic() {
      axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil/bod_pic",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.pic = response.data.tlc_pic;
          this.pic_name =
            response.data.tlc_pic + " - " + response.data.nama_pic;
          this.bod = response.data.tlc_bod;
          Event.$emit("getPicUser", this.pic);
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            if (this.mode === "Create") {
              this.displayMessage("noPICBOD");
              this.$router.go(-1);
            } else {
              this.pageLoading = false;
              this.loading = false;
            }
          }
        });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          pic: values.pic || "",
          bod: values.bod || "",
          type: values.type,
          catatan: this.data ? this.data.catatan : ''
        };

        Event.$emit("lapUmpd", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      fetchBodPic((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
    // handleBOD(data) {
    //   let filter = this.wo_bod.filter(
    //     (obj) => obj.tlc.toLowerCase().indexOf(data.toLowerCase()) >= 0
    //   );
    // },
  },
};
</script>

<style></style>
